import { isPwa } from '@/utils/utils'

export default () => ({
  pubgmDiscount: 0.92, // PUBGM的俄罗斯新客优惠
  isHorizontalScreen: false, // 是否是横屏
  isMobile: true, // 是否为移动端
  isDesktop: false, // 是否为桌面设备
  isMiuiBrowser: false, // 是否为国际版小米浏览器
  isXiaomiDevice: false, // 是否为小米设备
  isChromeBrowser: false, // 是否是chrome浏览器
  isApp: false, // 是否为APP
  gameName: '',
  source: '',
  isTurbo: false, // 用来控制 Game Turbo 小窗模式
  isPwa: !!isPwa(),
  region: 'id',
  currency: '', // 货币
  userInfo: null, //登录用户信息
  selectedSkuInfo: {},
  selectedPaymentInfo: {},
  createOrderState: null, // pending: 进行中, error: 出错
  gameUid: '',
  gameZoneId: '',
  members: {
    // 会员相关的数据
    userInfo: {}, // 会员信息
    userConfig: [], // 配置信息
    layerData: {}, // 弹层的数据层
    couponList: [], // 优惠券列表
    cardSwipes: [], // 左侧菜单的swipe数据
    modalBoxs: {
      list: [],
      // order: 3,
    }, // 会员弹层数据保留、保证弹层顺序  垃圾逻辑
  },
  openCookies: false, // 打开cookie setting
  cookieActions: 0, // 记录cookie [1]:全部同意; [2]:部分同意;[3]:全部拒绝的动作；
  cookiePolicyList: [], // 存储cookie policy 的数据
  cashierBasicInfo: null,
  isGetapps: false, // getapps定制
  isCuntryCookie: false, // 当前国家是否开启cookie功能
  paymentAccountInfo: null, // 钱包支付账户信息
  paymentPassword: '', // 加密后的支付密码
  shareInfos: null,
  shareReportStatus: false,
  fissionInfos: null,
  couponDisplayStatus: false,
  fissionGame: '',
  fissionGuestInfos: null, // 裂变活动被分享者携带的分享者的信息
  luckyDrawData: {}, // 抽奖活动信息
  layerWeights: {
    // 弹层权重的列表
    allList: [],
    actives: {},
  },
  // todo 新增游戏通过Vuex集中管理
  customGames: {
    skuOriginalList: [], // 原始数据
    activeSku: {}, // 选择SKU的套餐
    roleId: '', // 角色ID
    uid: '', // 用户的UID
    cpServerId: '', // 服务器ID
  },
  loginInfo: { exe: 0, status: 0 }, // [exe 1:已执行，0未执行 ] [status 0: 失败，1成功]
  showReqLoading: true, // 该值仅用于app侧边栏是否第二次不展示请求loading
  myTaxRate: 0, // 马来国家的税率[SST]
  isIAP: false,
  rankingActivityInfo: {},
  shareTitle: '',
  fissionFirstShareStatus: false,
  watchCouponState: false, // hack 解决popup的层级问题
  // searchSkuList: [], // hack 兼容GOS模糊搜索使用的数据【重写UID组件的时候、需要注意数据的传递】
  layoutVersion: 'version-2',
  hotfixIsFetchSuccess: true, // hotfixJs是否调用接口成功
  isInPubgmGameApp: false,
  showLandscapeGuide: false, // 是否展示横屏引导
  homeGameList: [], //首页游戏列表
  loginFromCouponPop: {}, // 从优惠券劵登录
  ABtestCode: '999999',
  countdownStatus: true, // 秒杀倒计时是否结束
})
